// Regions of the live student preview that a wizard step can point at. The step being
// configured highlights its region(s) so the instructor can see where on the student's
// screen that setting shows up.
//
//   task    the problem / task description
//   tests   the test-case list (or the GUI check list)
//   editor  the student's code editor (starter code / scaffold files)
//   run     the Run button and its output / terminal
//   chat    the AI chat panel
//
// A preview marks an element as a region by spreading regionAttrs(id, highlight) onto it.
// The highlight is drawn by CSS from data attributes (outline + glow, see
// livepreview.scss), so it never changes layout and needs no className merging.

export const PREVIEW_REGIONS = ['task', 'tests', 'editor', 'run', 'chat']

export const REGION_LABELS = {
  all: 'The whole student view',
  task: 'Problem description',
  tests: 'Test cases',
  editor: 'Code editor',
  run: 'Run & output',
  chat: 'AI chat',
}

export const regionAttrs = (id, highlight = []) => ({
  'data-lp-region': id,
  'data-lp-active': highlight.includes(id) ? 'true' : undefined,
})
